Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.polyfills = exports.storeKey = exports.Actions = exports.suggestions = exports.causes = exports.helper = undefined;
exports.default = configureStore;

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reducers = require('./reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _constants = require('./constants');

var _actions = require('./actions');

var Actions = _interopRequireWildcard(_actions);

var _helper = require('./utils/helper');

var helper = _interopRequireWildcard(_helper);

var _suggestions = require('./utils/suggestions');

var _suggestions2 = _interopRequireDefault(_suggestions);

var _polyfills = require('./utils/polyfills');

var _polyfills2 = _interopRequireDefault(_polyfills);

var _causes = require('./utils/causes');

var _causes2 = _interopRequireDefault(_causes);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var storeKey = _constants.STORE_KEY;
var suggestions = _suggestions2.default;
var causes = _causes2.default;
exports.helper = helper;
exports.causes = causes;
exports.suggestions = suggestions;
exports.Actions = Actions;
exports.storeKey = storeKey;
exports.polyfills = _polyfills2.default;
var composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : _redux.compose;
var enhancer = composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default));

function configureStore(initialState) {
  return (0, _redux.createStore)(_reducers2.default, initialState, enhancer);
}